import { createSlice } from '@reduxjs/toolkit';

// Obtener fecha actual para end date por defecto
const getTodayString = () => {
  const today = new Date();
  return today.toISOString().split('T')[0];
};

const filtersSlice = createSlice({
  name: 'filters',
  initialState: {
    startDate: '2025-01-01',
    endDate: getTodayString(),
    topN: 10,
    showFeminicidios: false,
    hurtoType: 'Hurto a persona',
    comparisonYear: 2024,
  },
  reducers: {
    setDates: (state, action) => {
      const { start, end } = action.payload;
      state.startDate = start;
      state.endDate = end;
    },
    setTopN: (state, action) => {
      state.topN = action.payload;
    },
    setShowFeminicidios: (state, action) => {
      state.showFeminicidios = action.payload;
    },
    toggleFeminicidios: (state) => {
      state.showFeminicidios = !state.showFeminicidios;
    },
    setHurtoType: (state, action) => {
      state.hurtoType = action.payload;
    },
    setComparisonYear: (state, action) => {
      state.comparisonYear = action.payload;
    },
    resetFilters: (state) => {
      state.startDate = '2025-01-01';
      state.endDate = getTodayString();
      state.topN = 10;
      state.showFeminicidios = false;
      state.hurtoType = 'Hurto a persona';
      state.comparisonYear = 2024;
    },
  },
});

export const { setDates, setTopN, setShowFeminicidios, toggleFeminicidios, setHurtoType, setComparisonYear, resetFilters } = filtersSlice.actions;

// Selectores
export const selectFilters = (state) => state.filters;
export const selectDates = (state) => ({
  start: state.filters.startDate,
  end: state.filters.endDate,
});
export const selectTopN = (state) => state.filters.topN;
export const selectShowFeminicidios = (state) => state.filters.showFeminicidios;
export const selectHurtoType = (state) => state.filters.hurtoType;
export const selectComparisonYear = (state) => state.filters.comparisonYear;

export default filtersSlice.reducer;
